"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatDate_1 = require("@/util/formatDate");
function PostIndexItem(posts) {
    return posts
        .map((post) => `
    <a href="${post.path}" data-link class="group block py-3 border-b border-solid border-line sm:grid sm:grid-cols-[96px_1fr_auto] sm:gap-4 sm:items-baseline">
      <div class="sm:hidden text-caption2 text-muted">${(0, formatDate_1.formatDate)(post.date)} · <span class="text-accent font-GmarketSansMedium">${post.category}</span></div>
      <span class="hidden sm:block text-caption1 text-muted">${(0, formatDate_1.formatDate)(post.date)}</span>
      <span class="block mt-1 sm:mt-0 min-w-0 font-GmarketSansMedium text-white-200 group-hover:text-accent">${post.title}</span>
      <span class="hidden sm:block text-caption1 font-GmarketSansMedium text-accent">${post.category}</span>
    </a>
  `)
        .join("");
}
exports.default = PostIndexItem;
